import axios from 'axios'

export default {
  state: {
    reports: [],
    report: {},
    filters: {},
    pagination: {}
  },
  mutations: {
    setReports(state, payload) {
      state.reports = payload
    },
    setReport(state, payload) {
      state.report = payload
    },
    setReportsFilters(state, payload) {
      state.filters = {...state.filters, ...payload}
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
  },
  actions: {
    queryReports({state, dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'results', {params: state.filters})
        .then(res => {
          commit('setReports', res.data.results)
          commit('setPagination', {per_page: res.data.pagination.per_page, total: res.data.pagination.total})
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    queryReport({state, dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'results/' + payload)
        .then(res => {
          commit('setReport', res.data)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    updateReport({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'results/' + payload[0], payload[1])
        .then(res => {
          dispatch('queryReports')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    destroyReport({dispatch, commit}, result_id) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'results/' + result_id)
          .then(res => {
            dispatch('queryReports')
            dispatch('setToast', {status: 'success', message: res.data})
            dispatch('setPreloader', false)
          })
          .catch(error => {
            dispatch('setToastHttpError', error.response, {root: true})
          })
    },
  },
  getters: {
    getReports(state) {
      return state.reports
    },
    getReport(state) {
      return state.report
    },
    getReportsPagination(state) {
      return state.pagination
    }
  }
}